<template>
    <div class="one-counter-area pt-100 pb-70">
        <div class="container">
            <div class="row text-center">
                <div class="col-sm-6 col-lg-3" v-for="item in countersToShow" :key="item.key">
                    <div class="counter-item-fixed">
                        <h3 class="counter-number">
                            <vue3-autocounter 
                                :startAmount="0" 
                                :endAmount="item.value" 
                                :duration="2" 
                            />
                        </h3>
                        <p class="counter-label">
                            {{ $t(item.labelLine1) }}<br v-if="item.labelLine2">
                            <span v-if="item.labelLine2">{{ $t(item.labelLine2) }}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Counter',
    data() {
        return {
            baseDate: new Date('2024-10-01'),

            baseCounters: {
                years: 5,
                repairs: 300,
                clients: 410,
                services: 204,
            },
        };
    },
    computed: {
        diffDays() {
            const today = new Date();
            const diffTime = today - this.baseDate;
            return Math.floor(diffTime / (1000 * 60 * 60 * 24));
        },
        dynamicCounters() {
            return {
                years: this.baseCounters.years,
                repairs: this.baseCounters.repairs + Math.floor(this.diffDays * 0.05),
                clients: this.baseCounters.clients + Math.floor(this.diffDays * 0.04),
                services: this.baseCounters.services + Math.floor(this.diffDays * 0.06),
            };
        },
        countersToShow() {
            return [
                {
                    key: 'years',
                    value: this.dynamicCounters.years,
                    labelLine1: 'counter.years.line1',
                    labelLine2: 'counter.years.line2',
                },
                {
                    key: 'repairs',
                    value: this.dynamicCounters.repairs,
                    labelLine1: 'counter.projects.line1',
                    labelLine2: 'counter.projects.line2',
                },
                {
                    key: 'clients',
                    value: this.dynamicCounters.clients,
                    labelLine1: 'counter.clients.line1',
                    labelLine2: 'counter.clients.line2',
                },
                {
                    key: 'services',
                    value: this.dynamicCounters.services,
                    labelLine1: 'counter.marketing.line1',
                    labelLine2: 'counter.marketing.line2',
                },
            ];
        },
    },
};
</script>
<style scoped>
.counter-item-fixed {
    text-align: center;
    margin-bottom: 30px;
}

.counter-number {
    font-size: 48px;
    font-weight: 700;
    line-height: 1.1;
    color: #fff;
    margin: 0 0 10px;
}

.counter-label {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.4;
    color: #fff;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: .05em;
}
</style>
